<template>
  <div class="main" v-if="porder_freight">
    <!-- {{ porder_detail }} -->
    <div class="huoyunTable">
      <div class="head tbc">
        <span>{{ $fanyi('发送方式') }}</span>
        <!--        -->

        <span>{{ $fanyi('物流单号') }}</span>
        <span>{{ $fanyi('计费重量') }}(kg)</span>
        <span>{{ $fanyi('美国派送时间') }}</span>
        <span>{{ $fanyi('费用($)') }}</span>
      </div>

      <div class="body">
        <div class="opt tbc" v-for="(item, i) in $parent.wuliu" :key="i">
          <span>{{ item.foreign_express ? item.foreign_express : '-------' }}({{
            item.type == 0 ? $fanyi('国际') : $fanyi('国内')
          }})</span>
          <span>{{
            item.foreign_express_no ? item.foreign_express_no : '-------'
          }}</span>
          <span>{{ item.weight ? item.weight : '-------' }}</span>
          <span>{{ item.created_at ? item.created_at : '-------' }}</span>
          <span>{{ item.price ? item.price : '-------' }}</span>
        </div>
      </div>
    </div>

    <div class="goodsTable">
      <div class="head">
        <!-- 箱号 -->
        <span class="sn tdc">{{ $fanyi('箱号') }}</span>
        <!-- 实际重量 -->
        <span class="weight tdc">{{ $fanyi('实际重量') }}(kg)</span>
        <!-- 长 -->
        <span class="long tdc">{{ $fanyi('长') }}(cm)</span>
        <!-- 宽 -->
        <span class="wide tdc">{{ $fanyi('宽') }}(cm)</span>
        <!-- 高 -->
        <span class="high tdc">{{ $fanyi('高') }}(cm)</span>
        <!-- 体积 -->
        <span class="volume tdc">{{ $fanyi('体积') }}(m³)</span>
        <!-- 物流单号 -->
        <!-- <span class="trackingNumber tdc">{{ $fanyi("物流单号") }}</span> -->
      </div>
      <div class="body">
        <div class="bodyOpt" v-if="porder_freight.length == 0">
          <div class="optBody notHaveData">{{ $fanyi('暂无数据') }}</div>
        </div>
        <div class="bodyOpt" v-else>
          <div class="optBody" v-for="(orderItem, orderIndex) in porder_freight" :key="orderIndex"
            @click="openOne(orderItem)">
            <!-- 箱号 -->
            <span class="sn tdc con">
              <span class="box">
                {{ orderItem.number }}
              </span>
            </span>
            <!-- 实际重量 -->
            <span class="weight tdc">{{ orderItem.weight }}</span>
            <!-- 长 -->
            <span class="long tdc">{{ orderItem.length }}</span>
            <!-- 宽 -->
            <span class="wide tdc">{{ orderItem.width }}</span>
            <!-- 高 -->
            <span class="high tdc">{{ orderItem.height }} </span>
            <!-- 体积 -->
            <span class="volume tdc">{{
              $fun.ceil(
                (orderItem.length * orderItem.width * orderItem.height) /
                1000000,
                3
              )
            }}</span>
            <!-- 物流单号 -->
            <!-- <span class="trackingNumber tdc">{{
              $parent.datas.express_no
            }}</span> -->
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="el-dialog-cus" :visible.sync="oneGoodsPackingQuantity" :lock-scroll="false" append-to-body>
      <div class="main">
        <div class="dangQianXiangHao">
          {{ $fanyi('当前箱号') }}：{{ oneData ? oneData.number : '' }}
        </div>
        <div>
          <el-table :data="oneData.porder_freight_detail" :header-cell-style="{
            'text-align': 'center',
            'background-color': '#F6F6F6',
            color: '#000000',
            'font-weight': '400',
          }" :cell-style="{ 'text-align': 'center', color: '#000000' }">
            <el-table-column property="order_detail" :label="$fanyi('订单号')" width="240px">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.order_detail.order_sn }}
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" :label="$fanyi('番号')">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.order_detail.sorting }}
                </div>
              </template>
            </el-table-column>
            <el-table-column property="date" :label="$fanyi('图片')">
              <template slot-scope="scope">
                <div>
                  <el-popover placement="right" trigger="hover">
                    <img :src="scope.row.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                    <img class="image" @click="
                      $fun.toCommodityDetails({
                        goods_id: item.goods_id,
                        shop_type: item.shop_type,
                      })
                      " :src="scope.row.order_detail.pic" alt="" slot="reference" />
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" :label="$fanyi('商品属性')" width="200px">
              <template slot-scope="scope">
                <el-popover placement="bottom" trigger="hover">
                  <div class="goodsDetailAll">
                    <div class="goodsDetailAllOneBox" v-for="(detailItem, detailIndex) in JSON.parse(
                      scope.row.order_detail.detail
                    )" :key="detailIndex" :title="detailItem.key + ':' + detailItem.value">
                      <h1 class="detailTitle">{{ detailItem.key }}</h1>
                      <p>
                        <span class="detailBody">{{ detailItem.value }}</span>
                      </p>
                    </div>
                  </div>
                  <div slot="reference" class="goodsDetail">
                    <div class="box">
                      <p v-for="(detailItem, detailIndex) in JSON.parse(
                        scope.row.order_detail.detail
                      )" :key="detailIndex" :title="detailItem.key + ':' + detailItem.value">
                        <span class="detailTitle">{{ detailItem.key }}</span> :
                        <span class="detailBody">{{ detailItem.value }}</span>
                      </p>
                    </div>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column property="num" :label="$fanyi('装箱数量')"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      oneGoodsPackingQuantity: false,
      oneData: {
        id: '',
        porder_sn: '',
        number: '',
        status: '1',
        length: '',
        width: '',
        height: '',
        weight: '',
        porder_freight_detail: [],
      },
    }
  },
  components: {},
  computed: {
    porder_freight() {
      if (
        this.$parent.datas.result &&
        this.$parent.datas.result.porder_freight
      ) {
        return this.$parent.datas.result.porder_freight
      }
    },
    porder_foreign_express() {
      if (
        this.$parent.datas.result &&
        this.$parent.datas.result.porder_foreign_express
      ) {
        return this.$parent.datas.result.porder_foreign_express
      }
    },
    huoYunData() {
      if (this.$parent.datas.result) {
        return {
          logistics: this.$parent.datas.result.logistics,
          express_no: this.$parent.datas.result.express_no,
          billing_parameter: this.$parent.datas.result.billing_parameter,
          amount: this.$parent.datas.result.amount,
        }
      }
    },
  },
  created() { },
  methods: {
    openOne(data) {
      this.oneData = data
      this.oneGoodsPackingQuantity = true

      this.$forceUpdate()
    },
  },
}
</script>
<style lang="scss" scoped="scoped">
@import '../../../../../../../css/mixin.scss';

.main {
  width: $pageWidth;
  margin: 0 auto 10px;
  background: #ffffff;
  border: 1px solid #e2e2e2;
  padding: 30px;
  font-size: 14px;
  border-radius: 6px;

  .huoyunTable {
    margin-bottom: 30px;

    .head {
      background: #bfd1ff;
      height: 56px;

      &.tbc {
        span {
          border: none !important;
        }
      }
    }

    .body {
      background-color: white;

      border-right: 1px solid #ededed;

      .opt {
        height: 60px;
      }
    }

    .tbc {
      display: flex;
      align-items: center;

      span {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        border-left: #ededed solid 1px;
        border-bottom: #ededed solid 1px;
      }
    }
  }

  .goodsTable {
    .head {
      height: 56px;
      background-color: rgba($color: #00c18b, $alpha: 0.4);
      display: flex;
      align-items: center;
    }

    .body {
      .bodyOpt {
        .optHead {
          height: 60px;
          display: flex;
          align-items: center;

          .title {
            font-size: 14px;
            color: #888888;
            line-height: 20px;
            margin-left: 20px;
          }

          .titlebody {
            font-size: 14px;
            color: #000000;
            line-height: 20px;
          }

          .downIcon {
            transition: 0.3s;
            line-height: 20px;
            transform: rotate(90deg);
            margin-left: 10px;

            &.open {
              transform: rotate(270deg);
            }
          }
        }

        .optBody {
          height: 60px;
          background: #fff;
          display: flex;
          align-items: center;
          border: solid 1px #ededed;
          border-bottom: none;
          margin-bottom: -1px;
          cursor: pointer;

          .box {
            border-radius: 4px;
          }

          &:hover {
            background-color: #fafafa;

            .box {
              display: block;
              width: 64px;
              height: 28px;
              background: #00c18b;
              color: white;
              border-radius: 4px;
              text-align: center;
              line-height: 28px;
            }
          }

          &.notHaveData {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: default;
          }

          .tdc {
            border-right: solid 1px #ededed;
            border-bottom: solid 1px #ededed;

            &:last-child {
              border-right: none;
            }
          }
        }
      }
    }

    .tdc {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      &.sn {
        flex: 0 0 150px;

        &.con {
          .box {
            display: block;
            width: 64px;
            height: 28px;
            border: solid 1px #00c18b;
            color: #00c18b;
            text-align: center;
            line-height: 28px;
          }
        }
      }

      &.trackingNumber {
        flex: 0 0 313px;
      }
    }
  }
}
</style>
